import { useAppSelector } from '@app/hooks/redux';
import store from '@app/store';
import { StateType } from '@app/types/reducer-state';

const getPermissionMap = (
  authPermissions: string[] = [],
  permissions: string[] = [],
) =>
  authPermissions.reduce(
    (acc: Record<string, boolean>, permission) => {
      if (permissions.includes(permission)) {
        acc[permission] = true;
      }
      return acc;
    },
    {} as Record<string, boolean>,
  );

/**
 * Use verifyPermission to retrieve data because hook cannot be used outside react component
 * @param permissions Array of permissions to verify
 * returns Object with user's permissions as keys
 */
export const verifyPermission = (permissions: Array<string>) => {
  const state = store.getState() as unknown as StateType;
  const authPermissions = state?.auth?.permissions;
  const normalizedPermissions = (permissions || []).map((p) =>
    p?.startsWith('!') ? p.slice(1) : p,
  );
  return getPermissionMap(authPermissions, normalizedPermissions);
};

/**
 * Custom hook to verify if the user has the required permissions
 * @param permissions Array of permissions to verify
 * returns Object with user's permissions as keys
 */
export default (permissions: Array<string>) => {
  const authPermissions = useAppSelector(
    ({ auth }: StateType) => auth?.permissions,
  );
  const normalizedPermissions = (permissions || []).map((p) =>
    p?.startsWith('!') ? p.slice(1) : p,
  );
  return getPermissionMap(authPermissions, normalizedPermissions);
};
